import { reducer, union } from "ts-action";
import { on } from "ts-action-immer";
import * as AC from "../actionCreators";

export type State = number[];

const initialState: State = [];

const submitInitActions = union(
  AC.userFilterPutFilterRequest,
  AC.userFilterDeleteFilterRequest,
  AC.userFilterPatchFilterRequest
);

const submitEndingActions = union(
  AC.userFilterPatchFilterSuccess,
  AC.userFilterPutFilterSuccess,
  AC.userFilterDeleteFilterSuccess,
  AC.userFilterPatchFilterError,
  AC.userFilterPutFilterError,
  AC.userFilterDeleteFilterError
);

const idsOfSubmittingFiltersReducer = reducer(
  initialState,
  on(...submitInitActions, (state, { payload }) => [
    ...state,
    payload.filterId,
  ]),
  on(...submitEndingActions, (state, { payload }) =>
    state.filter((id) => id !== payload.filterId)
  )
);

export default idsOfSubmittingFiltersReducer;
export type IdsOfSubmittingFilters = State;
